import { queryOptions } from "@tanstack/react-query";
import instance from "./axiosInstance";
import { Facility } from "types/facility.type";
import { Separator } from "types/separator/separator.type";
import { Customer } from "types/customer.type";
import { Uppdrag } from "types/uppdrag.type";
import { ScheduledMaintenanceItemWithRelationsDto } from "pages/app/service-schedule/service-schedule.dto";

const ENDPOINT = "/scheduled-maintenance";

export enum ScheduledMaintenanceQueryKey {
  GetList = "get-scheduled-maintenance-list",
  GetOne = "get-scheduled-maintenance-item",
}

export enum MaintenanceType {
  SixMonthsInspection = "SixMonthsInspection",
  FiveYearsInspection = "FiveYearsInspection",
  Tomning = "Tomning",
  WaterMeasurementProtocol = "WaterMeasurementProtocol",
}

export type ScheduledMaintenanceSortBy =
  | "nextMaintenanceDateInYYYYMM15"
  | "nextMaintenanceType"
  | "nextTomningDateInYYYYMM15"
  | "nextSixMonthsInspectionDateInYYYYMM15"
  | "nextFiveYearsInspectionDateInYYYYMM15"
  | "createdAt"
  | "updatedAt";

interface GetScheduledMaintenanceListParams {
  limit?: number;
  offset?: number;
  sortBy?: ScheduledMaintenanceSortBy;
  sortDirection?: "ASC" | "DESC";
  /** Fritext mot kundnamn, anläggningsnamn och anläggningsadress. */
  searchQuery?: string;
}

export interface ScheduledMaintenanceItem {
  id: string;
  separatorId: number;
  facilityId: number;
  createdAt: Date;
  updatedAt: Date;
  nextMaintenanceDateInYYYYMM15: Date;
  nextMaintenanceType: MaintenanceType;
  nextTomningDateInYYYYMM15?: Date | null;
  nextSixMonthsInspectionDateInYYYYMM15?: Date | null;
  nextFiveYearsInspectionDateInYYYYMM15?: Date | null;
  facility: Facility & {
    customer: Customer;
    separators: Separator[];
    uppdragList: Uppdrag[];
  };
}

export interface GetScheduledMaintenanceListResponse {
  items: ScheduledMaintenanceItem[];
  total: number;
  companyTotal: number;
}

export const getScheduledMaintenanceList = (
  params: GetScheduledMaintenanceListParams,
) =>
  queryOptions({
    queryKey: [ScheduledMaintenanceQueryKey.GetList, params],
    queryFn: async (): Promise<GetScheduledMaintenanceListResponse> =>
      (await instance.get(ENDPOINT, { params })).data,
  });

export const getScheduledMaintenanceItem = (id: number) =>
  queryOptions({
    queryKey: [ScheduledMaintenanceQueryKey.GetOne, id],
    queryFn: async (): Promise<ScheduledMaintenanceItemWithRelationsDto> =>
      (await instance.get(`${ENDPOINT}/${id}`)).data,
  });
